<div class="mode-legacy-dialog-footer">
  <ng-content></ng-content>
</div>
